export default class Bs4Stores {
  static li = [
    'suspendisse ultrices gravida dictum fusce ut placerat orci nulla pellentesque dignissim enim sit amet venenatis urna cursus eget nunc scelerisque viverra mauris in aliquam sem fringilla ut morbi tincidunt augue',
    'mattis enim ut tellus elementum sagittis vitae et leo duis ut diam quam nulla porttitor massa id neque aliquam vestibulum',
    'proin nibh nisl condimentum id venenatis a condimentum vitae sapien',
  ];
  
  static getLI = () => {
    return this.li[Math.floor(Math.random() * (this.li.length - 1))];
  }

  static stores = {};

  static getBs4Store(storeName) { 
    const store = Bs4Stores.stores[storeName];
    if (Array.isArray(store)) return store.map(item => Bs4Stores.getNormalizedVariant(item));
    return [];
  }

  static getNormalizedVariant(variant) {
    let [id, name, text, icon, style] = variant;    
    //(id, etykieta, opis tekstowy, akronim ikony, kod html kolorów tła- czcionki- opacity). 
    //text = text || this.getLI();
    //if (style && ! icon) icon = "fa-solid fa-font";
    return {id: String(id).trim(), name: String(name || ''), text: String(text || ''), icon: icon || null, style: style}
  }

  static getNormalizedIdName(id, name) {
    return {id: String(id).trim(), name: String(name)}
  }

  //For Tabulator
  static getValueLabel(storeName) { 
    const store = Bs4Stores.stores[storeName];
    if (Array.isArray(store)) return store.map(item => ({value: String(item[0]).trim(), label: String(item[1])}));
    return [];
  }

  static hasField(bs4Store, field) {
    const icon = bs4Store.filter(variant => variant[field]);
    return icon.length > 0;
  }
  
  //For Tabulator
  static getLookup(storeName) { 
    const store = Bs4Stores.stores[storeName];
    const lookup = {};
    if (Array.isArray(store)) store.forEach(row => {
      lookup[row[0]] = row[1];
    });
    return lookup;
  }

  static update (message) { 
    message._Komunikat?.ext_store.forEach(store => {
      Bs4Stores.stores[store.id] = store.items;
      //console.log('...Store...', store.items)
    })  
  }

  static idsToStoreObject(store, value) {
		if (!store) store = [];
		if (!Array.isArray(value)) return [];
    const storeObj = {};
    store.forEach(item => storeObj[item.id] = item);
    return value.map(id => storeObj[id]);
	}

  //nieznana wartość
  static addUnknownValuesToStore(store, value) {
		if (!store) store = [];
		if (!Array.isArray(value)) return store;
		try {		
			//Object to check presence.
			const tmpStore = {};
			store.forEach(item => {
				tmpStore[item.id] = item;
			});
			// Adding absentees.
			value.forEach(value => {
				if (value && !tmpStore[value]) {
					store.push({id: value, name: 'nieznana wartość'+':'+value});
				}
			});
		} catch(error) {
      console.log(error)
    }
		
		return store;
	}
}